<template>
  <div class="mobile-product-card-layout">
    <div class="top-section">
      <slot name="top-section" />
      <slot name="top-section-tag" />
    </div>
    <div class="bottom-section">
      <div class="content">
        <slot name="content" />
      </div>
      <div class="footer">
        <slot name="footer" />
      </div>
    </div>
    <slot name="date" />
  </div>
</template>

<style scoped lang="scss">
.mobile-product-card-layout {
  display: grid;
  grid-auto-rows: auto;

  border-radius: var(--border-radius-8);
  border: 1px solid var(--color-neutral-30);
  background-color: var(--color-white);
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;
  padding: var(--spacing-12);
  gap: var(--spacing-12);

  .top-section {
    width: 100%;
    min-width: 0;
    height: auto;
    border-radius: var(--border-radius-8);
    overflow: hidden;
    position: relative;
  }

  .bottom-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;

    .content {
      border-bottom: unset;
      border-bottom-left-radius: unset;
      flex: 1;
    }

    .footer {
      border: unset;
      border-bottom-left-radius: var(--border-radius-8);
      border-top-right-radius: unset;
    }
  }
}
</style>
